// Updated 1/20/2022

const decklists = [
    // Swordcraft
    'Evo Rally Sword',
    'Aggro Rally Sword',

    // Forestcraft
    'Sekka Forest',
    'Control Forest',
    'Ladica Forest',
    'Hybrid Forest',

    // Runecraft
    'Chaos Rune',
    'Spellboost Rune',
    'Earth Rite Rune',
    "Mysteria Rune",
    'Yukishima Rune',

    // Dragoncraft
    'Burn Dragon',
    'Buff Dragon',
    'Face Dragon',
    'Jerry Dragon',

    // Shadowcraft
    'Ceres OTK Shadow',
    'Evo Last Words Shadow',
    'Flame & Glass Shadow',

    // Bloodcraft
    'Handless Blood',
    'Evo Blood',
    'Mono Blood',

    // Havencraft
    'Ward Haven',
    'Heal Haven',
    'Amulet Haven',

    // Portalcraft
    'Artifact Portal',
    'Magna Saber Portal'
]

export default decklists